import {FieldConfig} from '../../dynamic-field/field.config';

export interface SlideToggleFieldConfig extends FieldConfig<boolean> {
    allowLabelCollapse?: boolean;
    slideToggleTooltip?: string;
}
